import React, { useCallback, useContext } from 'react'
import Accounts from './Accounts'
import * as actions from '../store/actions'
import { AppContext } from '../../../global'
import { useParams } from 'react-router-dom'
import { Params } from '../../../modules/types'

function AccountsRoute() {
  const { state, execute } = useContext(AppContext)
  const { partnerId } = useParams() as Params

  const loadAccountsSearchResults = useCallback(
    async function(partnerId: string, search: string, includeDeactivated: boolean, page: number) {
      await execute(actions.loadAccountSearch(partnerId, search, includeDeactivated, page))
    },
    [execute]
  )

  const loadAccountFilters = useCallback(
    async function(accountId: string) {
      await execute(actions.loadAccountFilters(accountId))
    },
    [execute]
  )

  return (
    <Accounts
      state={state.accounts}
      partnerId={partnerId}
      loadAccountsSearchResults={loadAccountsSearchResults}
      loadAccountFilters={loadAccountFilters} />
  )
}

export default AccountsRoute
